import React from "react";

import Intro from "./header/Intro";
import Navbar from "./header/Navbar";
import Contact from "./header/Contact";

import About from "./main/About";
import Education from "./main/Education";
import Experience from "./main/Experience";
import Projects from "./main/Projects";
import Personal from "./main/Personal";

function WebPage({ activeSection }) {
    return (
        <div className="web-page-wrapper">
            <div className="left">
                <header>
                    <Intro />
                    <Navbar activeSection={activeSection} />
                    <Contact print />
                </header>
            </div>
            <div className="right">
                <main>
                    <About activeSection={activeSection} />
                    <Education activeSection={activeSection} />
                    <Experience activeSection={activeSection} />
                    <Projects activeSection={activeSection} />
                    <Personal activeSection={activeSection} />
                </main>
                <footer>
                    <p>
                        2024 Solène PETTIER
                    </p>
                </footer>
            </div>
        </div>
    )
}

export default WebPage;